import script from "./History.vue?vue&type=script&lang=ts&setup=true"
export * from "./History.vue?vue&type=script&lang=ts&setup=true"

import "./History.vue?vue&type=style&index=0&id=86d70346&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d70346"]])

export default __exports__